import apiClient from '../services/apiClient';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';



const GameControl = () => {
  const [gameControl, setSettings] = useState({
    max_lose_capacity: '',
    min_lose_capacity: '',
    admin_win_lose: '',
    winning_percentage: '',
  });

  const [loading, setLoading] = useState(false);

  const fetchSetting = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/game-settting`);
      if (response?.data) {
        setSettings(response.data);
      }
    } catch (error) {
      console.error("Error fetching gameControl:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSetting();
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await apiClient.put(`/edit-game-setting`, {
        max_lose_capacity: parseFloat(gameControl.max_lose_capacity),
        min_lose_capacity: parseFloat(gameControl.min_lose_capacity),
        admin_win_lose: parseFloat(gameControl.admin_win_lose),
        winning_percentage: parseFloat(gameControl.winning_percentage),
        id: 1,
      });

      toast.success('Game control updated successfully!');
      fetchSetting();
    } catch (error) {
      console.error("Error updating gameControl:", error);
      toast.error('Failed to update gameControl.');
    }
  };

  return (
    <div className="ml-0 lg:ml-[256px] p-6 min-h-screen">
      <div className="max-w-2xl mx-auto bg-slate-900 border border-slate-700/60 shadow-2xl  rounded-2xl shadow-lg p-8 relative">
        {/* Refresh Button */}
        <button
          onClick={fetchSetting}
          disabled={loading}
          className="absolute top-4 right-4 bg-slate-950/50 border border-slate-700/50 focus:border-indigo-500  hover:bg-gray-600 transition text-white px-4 py-2 rounded-md text-sm shadow-md"
        >
          {loading ? 'Refreshing...' : '🔄 Refresh'}
        </button>

        <h2 className="text-3xl font-bold text-white mb-6 text-center">
          🎮 Game Control Settings
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <div className="text-center">
              <label className="block text-sm font-medium text-gray-300 mb-1">
                Admin Win Lose Status
              </label>
              <div
                className={`w-full rounded-xl p-3 border font-semibold
                  ${parseFloat(gameControl?.admin_win_lose) < 0
                    ? 'bg-red-700 border-red-600 text-red-200'
                    : 'bg-green-700 border-green-600 text-green-200'
                  }`}
              >
                {parseFloat(gameControl?.admin_win_lose) < 0 ? (
                  <>
                    <span className="mr-1">🔻</span>
                    {gameControl?.admin_win_lose}
                  </>
                ) : (
                  <>
                    <span className="mr-1">✅</span>
                    {gameControl?.admin_win_lose}
                  </>
                )}
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Max Lose Capacity
            </label>
            <input
              type="number"
              step="0.01"
              name="max_lose_capacity"
              value={gameControl?.max_lose_capacity}
              onChange={handleChange}
              className="w-full rounded-xl bg-slate-950/50 border border-slate-700/50 focus:border-indigo-500  text-white border  focus:ring-2 focus:ring-blue-500 p-3"
              placeholder="Enter max lose limit"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Min Lose Capacity
            </label>
            <input
              type="number"
              step="0.01"
              name="min_lose_capacity"
              value={gameControl?.min_lose_capacity}
              onChange={handleChange}
              className="w-full rounded-xl bg-slate-950/50 border border-slate-700/50 focus:border-indigo-500  text-white border  focus:ring-2 focus:ring-blue-500 p-3"
              placeholder="Enter min lose limit"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Winning Percentage
            </label>
            <input
              type="number"
              step="0.01"
              name="winning_percentage"
              value={gameControl?.winning_percentage}
              onChange={handleChange}
              className="w-full rounded-xl bg-slate-950/50 border border-slate-700/50 focus:border-indigo-500  text-white border  focus:ring-2 focus:ring-blue-500 p-3"
              placeholder="Enter winning percentage"
            />
          </div>
          <div className="hidden">
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Admin Win Lose
            </label>
            <input
              type="number"
              step="0.01"
              name="admin_win_lose"
              value={gameControl?.admin_win_lose}
              onChange={handleChange}
              className="w-full rounded-xl bg-slate-950/50 border border-slate-700/50 focus:border-indigo-500  text-white border  focus:ring-2 focus:ring-blue-500 p-3"
              placeholder="Enter admin win/lose ratio"
            />
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 transition text-white font-semibold w-full py-3 rounded-xl shadow-md"
            >
              💾 Update Control
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GameControl;
